import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ConfigChartIcon = createIcon(
  'ConfigChart',
  <path d="M19,3 C20.1,3 21,3.9 21,5 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,5 C3,3.9 3.9,3 5,3 Z M17,9 L11.1666667,14 L8.66666667,13 L7,17 L17,17 L17,9 Z" />
);

export default ConfigChartIcon;
